import { useTranslation } from "utils/use-translation"
import Banner from "../banner"

import styles from './styles.module.scss'

const FirstLoanBanner = ({ discount }: { discount: string }) => {
    const { t, replacePlaceholders, replacePlaceholdersWithElements } = useTranslation()

    return (
        <Banner>
            <span className={styles.tag}>{t('special_offer_tag')}</span>
            <p className={styles.description}>
                {replacePlaceholdersWithElements(t('sign_up_get_discount_for_first_loan'), {
                    apr_off: <>
                        <br />
                        <span className={styles.discount}>{replacePlaceholders(t('number_apr_off'), { number: discount })}</span>
                    </>
                })}
            </p>
        </Banner>
    )
}

export default FirstLoanBanner